import { isNullOrEmpty } from "../../../utils/formValidation";


export function loadValues(
    i: number | undefined, 
    handleInputChange: (id: string, value?: any) => Promise<void>, 
    objAttachment: any 
) {
    handleInputChange(`ddlBusinessPlace_IN_${i}`, objAttachment.business_place);
    handleInputChange(`txt_InvoiceNumber_IN_${i}`, objAttachment.invoice_number);
    handleInputChange(`txt_E_InvoiceNumber_IN_${i}`, objAttachment.e_Invoice_Number);
    handleInputChange(`txtVendorGSTNumber_IN_${i}`, objAttachment.vendor_Number);

    if (objAttachment.tax_Not_Applicable == 1){
        handleInputChange(`chkbx_TaxNotApply_${i}`, "1");
    }
    else{
        handleInputChange(`chkbx_TaxNotApply_${i}`, "0");
    }
        
   
}

export function load_IN_CustomFields(
    i: number | undefined, 
    handleInputChange: (id: string, value?: any) => Promise<void>, 
    objAttachment: any, 
    onLoad?: string | null, 
    ) {
    // bindDDLBusinessPlace_IN(i,`ddlBusinessPlace_IN_${i}`, handleBindDDL);
    let dvElement = document.querySelector<HTMLElement>(`#div_TaxApplicable${i}`);
    if (!isNullOrEmpty(dvElement)) {
        handleInputChange(`hidValidate_IN${i}`, 1);
    } 
    else{
        handleInputChange(`hidValidate_IN${i}`, 0);
        if (isNullOrEmpty(onLoad)) {
             clearValues(i, handleInputChange);
        }
        else {
            loadValues(i, handleInputChange, objAttachment);
        }
    }
     
}


export function clearValues(
    i: number | undefined, 
    handleInputChange: (id: string, value?: any) => Promise<void>, 
) {
    handleInputChange(`ddlBusinessPlace_IN_${i}`, "");
    handleInputChange(`txt_InvoiceNumber_IN_${i}`,  "");
    handleInputChange(`txt_E_InvoiceNumber_IN_${i}`,  "");
    handleInputChange(`txtVendorGSTNumber_IN_${i}`,  "");
    handleInputChange(`chkbx_TaxNotApply_${i}`, "0");
}


export function bindDDLBusinessPlace_IN(
    i: number | undefined, 
    inputId: string,
    handleBindDDL?: (id: string, value?: any) => void
) {
     let businessPlaceData = !isNullOrEmpty(localStorage.getItem("BusinessPlaceData"))  ? JSON.parse(localStorage.getItem("BusinessPlaceData")!) : null;
   
     handleBindDDL && handleBindDDL(`${inputId}`, businessPlaceData);
    // $(BusinessPlaceData).each(function (i, d) {
    //     $(display_id).append($('<option></option>').attr('value', d.id).attr('label', d.text).html(d.text));
    // })

}

